import React from 'react'
import { Application } from '../../Application';

type BuilderContextProps = { 
    builder: Application,
};

const BuilderContext = React.createContext<Partial<BuilderContextProps>>({})

export const BuilderProvider =BuilderContext.Provider
export const BuilderConsumer = BuilderContext.Consumer

export default BuilderContext